import { useSiteContent } from '@/hooks/useSiteContent';
import ContentState from '@/components/feature/ContentState';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface ServicesCTAData {
  headline: string;
  subheadline: string;
  description: string;
  primaryCta: string;
  secondaryCta: string;
  image: string;
}

export default function ServicesCTA() {
  const { data, loading, error, refresh } = useSiteContent<ServicesCTAData>(
    'special_services_cta',
  );
  const { t } = useTranslation();

  if (loading || error || !data) {
    return <ContentState loading={loading} error={error} ready={!!data} onRetry={refresh} />;
  }

  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      <img
        src={data.image}
        alt={t('ss.ctaAlt')}
        title={t('ss.ctaTitle')}
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-black/50" />

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center">
        <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-3">
          {data.headline}
        </h2>
        <p className="font-heading text-lg md:text-xl font-semibold text-accent-400 mb-4">
          {data.subheadline}
        </p>
        <p className="text-white/80 text-sm md:text-base max-w-lg mx-auto mb-8">
          {data.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#plan-my-trip"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-accent-500 text-white font-medium text-sm rounded-full hover:bg-accent-600 transition-colors whitespace-nowrap"
          >
            {data.primaryCta}
            <i className="ri-arrow-right-line" />
          </a>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-7 py-3.5 border border-white/40 text-white font-medium text-sm rounded-full hover:bg-white/10 transition-colors whitespace-nowrap"
          >
            {data.secondaryCta}
            <i className="ri-mail-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}